import { OrthodonticsEnum } from "requests";

export const ORTHODONTICS_OPTIONS = [
  { value: OrthodonticsEnum.ImpressionModel, label: "Impression/Model" },
  { value: OrthodonticsEnum.InclinePlane, label: "Incline plane" },
  {
    value: OrthodonticsEnum.BracketPlacementElastics,
    label: "Bracket placement/elastics"
  },
  { value: OrthodonticsEnum.SplintRemoval, label: "Splint Removal" },
  {
    value: OrthodonticsEnum.MaxillaryExpansionDevice,
    label: "Maxillary Expansion Device"
  },
  { value: OrthodonticsEnum.Adjustment, label: "Adjustment" }
];
